import type { Icon } from '../../../src/lib/types'
export const mdiFormDropdown: Icon = {
  "id": "form-dropdown",
  "name": "Form Dropdown",
  "path": "M17 5H20L18.5 7L17 5M3 2H21C22.11 2 23 2.9 23 4V8C23 9.11 22.11 10 21 10H16V20C16 21.11 15.11 22 14 22H3C1.9 22 1 21.11 1 20V4C1 2.9 1.9 2 3 2M3 4V8H14V4H3M21 8V4H16V8H21M3 20H14V10H3V20M5 12H12V14H5V12M5 16H12V18H5V16Z",
  "as": [],
  "tags": [
    "Form"
  ]
}
export default mdiFormDropdown